import {PrimeIcons} from "primereact/api";
import {Button} from "primereact/button";

import AppreciationSectionIcon from "./appreciation/AppreciationSectionIcon";

export interface AppreciationRef {
    page: string;
    tab: string;
    section: string;
}

interface CollapsibleTitleButtonProps {
    label: string;
    isExpanded: boolean;
    onToggle: () => void;
    /** When given, an appreciation icon is rendered right after the button. */
    appreciation?: AppreciationRef;
    className?: string;
}

/**
 * Chevron + label toggle button shared by every collapsible section/group header (object-page
 * section titles, indication-table group headers, the comparables/explanations toggles) — same
 * PrimeReact secondary-text button, same color (`--text-color`, since a plain `color: inherit`
 * here resolves to nothing and falls back to UA-black). Callers keep their own outer layout
 * (wrapping element, flex/margin classes) and pass it via `className`.
 */
export default function CollapsibleTitleButton({
    label,
    isExpanded,
    onToggle,
    appreciation,
    className = "",
}: CollapsibleTitleButtonProps) {
    return (
        <>
            <Button
                icon={isExpanded ? PrimeIcons.CHEVRON_DOWN : PrimeIcons.CHEVRON_RIGHT}
                label={label}
                text
                severity="secondary"
                size="large"
                className={`collapsible-title-button ${className}`}
                onClick={onToggle}
            />
            {appreciation && (
                <AppreciationSectionIcon
                    page={appreciation.page}
                    tab={appreciation.tab}
                    section={appreciation.section}
                />
            )}
        </>
    );
}
